import mixpanel from 'mixpanel-browser';

/**
 * Mixpanel product analytics — a second, optional analytics sink alongside
 * Firebase Analytics. Everything is gated on VITE_MIXPANEL_TOKEN, so the app
 * runs fine (and tracks nothing) when the token is absent.
 */
const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined;

export const isMixpanelEnabled = Boolean(TOKEN);

let ready = false;

export function initMixpanel(): void {
  if (!TOKEN || ready) return;
  try {
    mixpanel.init(TOKEN, {
      debug: import.meta.env.DEV,
      persistence: 'localStorage',
      track_pageview: true,
    });
    ready = true;
  } catch (error) {
    console.error('[mixpanel] init failed', error);
  }
}

type TrackProps = Record<string, string | number | boolean | null | undefined>;

export function mpTrack(event: string, props?: TrackProps): void {
  if (!ready) return;
  try {
    mixpanel.track(event, props);
  } catch (error) {
    console.error('[mixpanel] track failed', error);
  }
}

/** Tie subsequent events to a signed-in user. Call on sign-in. */
export function mpIdentify(userId: string, traits?: TrackProps): void {
  if (!ready) return;
  try {
    mixpanel.identify(userId);
    if (traits) mixpanel.people.set(traits);
  } catch (error) {
    console.error('[mixpanel] identify failed', error);
  }
}

/** Clear identity + start a fresh anonymous id. Call on sign-out. */
export function mpReset(): void {
  if (!ready) return;
  try {
    mixpanel.reset();
  } catch (error) {
    console.error('[mixpanel] reset failed', error);
  }
}
